module.exports = __webpack_public_path__ + "media/images/logo-manager-a2482e4f628ff3fc7d09bf949a2d538d.png";